var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusAreaListeningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hardware"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_23111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 23.3337C30.9205 23.3337 31.6667 24.0799 31.6667 25.0003V28.3337C31.6667 29.2503 30.9167 30.0003 30 30.0003C29.0795 30.0003 28.3333 29.2541 28.3333 28.3337V25.0003C28.3333 24.0798 29.0795 23.3337 30 23.3337ZM10 23.3337C10.9205 23.3337 11.6667 24.0799 11.6667 25.0003V28.3337C11.6667 29.2541 10.9205 30.0003 10 30.0003C9.08333 30.0003 8.33333 29.2503 8.33333 28.3337V25.0003C8.33333 24.0799 9.07952 23.3337 10 23.3337ZM20 1.66699C11.7167 1.66699 5 8.38366 5 16.667V28.3337C5 31.1003 7.23333 33.3337 10 33.3337C12.7614 33.3337 15 31.0951 15 28.3337V23.3337C15 21.4927 13.5076 20.0003 11.6667 20.0003C9.82572 20.0003 8.33333 18.5079 8.33333 16.667C8.33333 10.217 13.55 5.00033 20 5.00033C26.45 5.00033 31.6667 10.217 31.6667 16.667C31.6667 18.5079 30.1743 20.0003 28.3333 20.0003C26.4924 20.0003 25 21.4927 25 23.3337V28.3337C25 31.0951 27.2386 33.3337 30 33.3337C32.7667 33.3337 35 31.1003 35 28.3337V16.667C35 8.38366 28.2833 1.66699 20 1.66699Z",
    fill: "url(#paint0_linear_1433_23111)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_23111",
    x1: 5,
    y1: 1.66699,
    x2: 36.6204,
    y2: 31.6232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63C276"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_23111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusAreaListeningIcon);
export default __webpack_public_path__ + "static/media/FocusAreaListeningIcon.22ead400c42500b110d26d508b6014eb.svg";
export { ForwardRef as ReactComponent };